import {
  Alert,
  Button,
  CardsCol,
  CardsRow,
  PageHeading,
  Page,
  ConsoleCard,
} from 'admin-web-ui'
import React, { useState } from 'react'
import styled from 'styled-components'
import { useConsoleContext } from '../../containers/Console'
import { EditProfileForm } from './EditProfileForm'
import { ChangePasswordModal, GlobalSignOutModal } from './modals'

export const CardH2 = styled.h2`
  margin-bottom: 28px;
`

const SecurityGroup = styled.div`
  margin-bottom: 18px;
`

const CardH3 = styled.h3`
  font-size: 16px;
`

export const EditProfile: React.FC = () => {
  const { me } = useConsoleContext()
  const [changePasswordModalOpen, setChangePasswordModalOpen] =
    useState<boolean>(false)
  const [globalSignOutModalOpen, setGlobalSignOutModalOpen] =
    useState<boolean>(false)
  const meProjects =
    me?.projects?.length !== undefined && me.projects.length > 0

  return (
    <Page>
      <PageHeading>User Profile</PageHeading>
      {!meProjects && (
        <CardsRow>
          <CardsCol span={24}>
            <Alert
              type="warning"
              message="No Project Access"
              description="You currently don't have access to view any project with this account. Contact your administrator to add you to a project."
              showIcon
            />
          </CardsCol>
        </CardsRow>
      )}
      <CardsRow>
        <CardsCol span={24}>
          <ConsoleCard>
            <CardH2>Your Information</CardH2>
            <EditProfileForm />
          </ConsoleCard>
        </CardsCol>
      </CardsRow>
      <CardsRow>
        <CardsCol span={24}>
          <ConsoleCard>
            <CardH2>Security</CardH2>
            <SecurityGroup>
              <CardH3>Password</CardH3>
              <Button
                id="EditProfile__change-password-btn"
                type="default"
                shape="round"
                size="large"
                onClick={() => setChangePasswordModalOpen(true)}
              >
                Change Password
              </Button>
            </SecurityGroup>
            <SecurityGroup>
              <CardH3>Global Sign Out</CardH3>
              <Button
                id="EditProfile__global-sign-out-btn"
                type="default"
                shape="round"
                size="large"
                onClick={() => setGlobalSignOutModalOpen(true)}
              >
                Sign out of all devices
              </Button>
            </SecurityGroup>
          </ConsoleCard>
        </CardsCol>
      </CardsRow>
      <ChangePasswordModal
        visible={changePasswordModalOpen}
        onClose={() => setChangePasswordModalOpen(false)}
      />
      <GlobalSignOutModal
        visible={globalSignOutModalOpen}
        onCancel={() => setGlobalSignOutModalOpen(false)}
      />
    </Page>
  )
}
